import {
  PersistedObjectSource,
  PersistedObjectSourceName,
} from '@jupiterone/jupiter-types';
import { formatJ1QueryValue } from '@jupiterone/jupiter-web-toolkit';
import { DescribedEntity, Entity, Vertex } from '../../../types';
import { describedEntityProperties } from '../../util/properties';

export const handleFindRelated = (
  _propertyName: string,
  propertyValue: any
) => {
  const value = formatJ1QueryValue(propertyValue);
  const searchString = Array.isArray(propertyValue)
    ? propertyValue.join(' ')
    : propertyValue;
  const queryString = _propertyName.startsWith('tag.')
    ? `query=${encodeURIComponent(`Find * with [${_propertyName}]=${value}`)}`
    : `query=${encodeURIComponent(`"${searchString}"`)}`;
  window.open(`/landing?${queryString}`);
};

export const handleFindSimilar = (
  propertyName: string,
  propertyValue: any,
  type: string
) => {
  const name = /[^a-zA-Z0-9_.]/.test(propertyName)
    ? `[${propertyName}]`
    : propertyName;
  const value = formatJ1QueryValue(propertyValue);
  const filter = `with ${name}=${value}`;

  const searchQuery = `find ${type} ${filter}`;
  const queryString = `query=${encodeURIComponent(searchQuery)}`;
  window.open(`/landing?${queryString}`);
};

const getSource = (properties?: Entity['properties']) => {
  if (!properties?._source) return 'api';
  if (PersistedObjectSource.isIntegrationSource(properties._source)) {
    return properties._integrationInstanceId || 'api';
  } else if (PersistedObjectSource.isPowerupSource(properties._source)) {
    return properties._powerupName || 'api';
  } else {
    return properties._source;
  }
};

export const vertexToDescribedEntity = (vertex: Vertex): DescribedEntity => {
  const isIntegrationEntity = PersistedObjectSource.isIntegrationSource(
    (vertex.entity._source || 'api') as PersistedObjectSourceName
  );
  return {
    _id: vertex.entity._id,
    _key: vertex.entity._key,
    _type: vertex.entity._type || [],
    _class: vertex.entity._class || [],
    _source: vertex.entity._source,
    source: getSource(vertex.entity),
    isIntegrationEntity,
    displayName: vertex.entity.displayName || 'NO:displayName',
    deleted: !!(
      vertex.entity._deleted ||
      vertex.entity._deletedOn ||
      vertex.entity._endOn
    ),
    deletedOn: vertex.entity._deletedOn || vertex.entity._endOn,
    webLink: vertex.properties.webLink,
    isShodanLink: !!(
      vertex.properties._class?.includes('Host') &&
      vertex.properties.publicIpAddress
    ),
    publicIpAddress: vertex.properties.publicIpAddress,
    properties: describedEntityProperties(
      { ...vertex.properties, ...vertex.entity },
      vertex.entity._class
    ).sort((a, b) => {
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      else if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
      return 0;
    }),
  };
};
